import * as React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

class GenericCarousel extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { slides, showArrows, showDots, infinite } = this.props;

        const Arrow = props => {
            let className = props.type === 'next' ? 'next-arrow' : 'prev-arrow';
            className += ' arrow';
            const char =
                props.type === 'next' ? (
                    <img src='images/right-arrow-blue.png' />
                ) : (
                    <img src='images/left-arrow-blue.png' />
                );
            return (
                <span className={className} onClick={props.onClick}>
                    {char}
                </span>
            );
        };

        return (
            <Slider
                arrows={showArrows}
                nextArrow={<Arrow type='next' />}
                prevArrow={<Arrow type='prev' />}
                dots={showDots}
                infinite={infinite}
            >
                {slides}
            </Slider>
        );
    }
}

GenericCarousel.defaultProps = {
    showArrows: true,
    showDots: true,
    infinite: true
}

GenericCarousel.propTypes = {
    slides: PropTypes.node.isRequired, // jsx array of the slides to show
    showArrows: PropTypes.bool,
    showDots: PropTypes.bool,
    infinite: PropTypes.bool
}


export default GenericCarousel;
